export default __webpack_public_path__ + "53540a9cfa099210310e65d4dec4b057.svg";